const topicTags = [
  { label: '热血冒险', count: '3.2万', hot: true },
  { label: '恋爱甜宠', count: '2.8万', hot: true },
  { label: '悬疑推理', count: '1.9万', hot: false },
  { label: '奇幻异世界', count: '2.5万', hot: true },
  { label: '都市生活', count: '1.6万', hot: false },
  { label: '古风仙侠', count: '2.1万', hot: false },
  { label: '搞笑日常', count: '1.8万', hot: false },
  { label: '恐怖惊悚', count: '1.2万', hot: false },
  { label: '科幻未来', count: '1.5万', hot: false },
  { label: '新番速递', count: '4.1万', hot: true },
  { label: '完结神作', count: '5.3万', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100 scroll-mt-header">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热门话题</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">当下最受读者关注的热门漫画话题与类型标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((tag) => (
            <a
              key={tag.label}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group inline-flex items-center gap-2 px-5 py-3 rounded-xl border transition-all duration-300 cursor-pointer whitespace-nowrap ${
                tag.hot
                  ? 'bg-accent-100/80 border-accent-300/60 hover:bg-accent-200/80'
                  : 'bg-background-50 border-background-200/70 hover:bg-background-200'
              }`}
            >
              {tag.hot && <i className="ri-fire-line text-accent-500 text-sm"></i>}
              <span className={`text-sm font-medium ${tag.hot ? 'text-accent-800' : 'text-foreground-700'}`}>
                {tag.label}
              </span>
              <span className={`text-xs ${tag.hot ? 'text-accent-600' : 'text-foreground-400'}`}>
                {tag.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}